var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7149 10.2857L15.4292 21.8572L10.2863 18M18.9099 34.415C18.319 34.6428 17.6645 34.6428 17.0737 34.415C12.4635 32.6448 8.49866 29.5182 5.70292 25.4474C2.90716 21.3768 1.41205 16.5538 1.41504 11.6155V3.9647C1.41504 3.28833 1.68373 2.63964 2.162 2.16138C2.64028 1.68312 3.28894 1.41443 3.96531 1.41443H32.0183C32.6945 1.41443 33.3433 1.68312 33.8216 2.16138C34.2999 2.63964 34.5686 3.28833 34.5686 3.9647V11.6155C34.5714 16.5538 33.0764 21.3768 30.2807 25.4474C27.4848 29.5182 23.5201 32.6448 18.9099 34.415Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.02bec59cc43db4aa08eb8488f3ba7d6f.svg";
export { ForwardRef as ReactComponent };